import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { plainToClass } from "class-transformer";
import { Observable } from "rxjs";
import { IssuingEntity } from "../models/issuingEntity";
import { Program } from "../models/program";
import { User } from "../models/user";
import { SettingsService } from "../settings/settings.service";
import { environment } from "./../../../environments/environment";

@Injectable()
export class AuthenticationService {
  constructor(private http: HttpClient, private settings: SettingsService) {}

  loginCognito(): any {
    const urlCognito =
      environment.cognitoUrl +
      "login?" +
      "client_id=" +
      environment.cognitoClientId +
      "&" +
      "response_type=" +
      environment.cognitoResponseType +
      "&" +
      //'scope='+environment.cognitoScope+'&'+
      "redirect_uri=" +
      environment.cognitoRedirectUrl;

    window.location.href = urlCognito;
  }

  getTokens(code): any {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set(
        "Authorization",
        "Basic " +
          btoa(
            environment.cognitoClientId + ":" + environment.cognitoClientSecret
          )
      );

    let params = new HttpParams()
      .set("client_id", environment.cognitoClientId)
      .set("grant_type", "authorization_code")
      .set("code", code)
      .set("redirect_uri", environment.cognitoRedirectUrl);

    return this.http.post(environment.cognitoUrl + "oauth2/token", params, {
      headers: headers,
    });
  }

  refreshToken(refreshToken): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set(
        "Authorization",
        "Basic " +
          btoa(
            environment.cognitoClientId + ":" + environment.cognitoClientSecret
          )
      );

    let params = new HttpParams()
      .set("client_id", environment.cognitoClientId)
      .set("grant_type", "refresh_token")
      .set("refresh_token", refreshToken);

    return this.http.post(environment.cognitoUrl + "oauth2/token", params, {
      headers: headers,
    });
  }

  logout(): any {
    this.clearStorage();
    const urlCognito =
      environment.cognitoUrl +
      "logout?" +
      "response_type=" +
      environment.cognitoResponseType +
      "&" +
      "client_id=" +
      environment.cognitoClientId +
      "&" +
      "redirect_uri=" +
      environment.cognitoRedirectUrl +
      "&";
    window.location.href = urlCognito;
  }
  get isAuthenticated(): any {
    return localStorage.getItem("currentUser") != null;
  }

  clearStorage(): any {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("issuingEntity");
    localStorage.removeItem("currentProgram");
  }

  currentUser(): User {
    try {
      const transformed = plainToClass(
        User,
        JSON.parse(localStorage.getItem("currentUser"))
      );

      if (transformed) {
        if (Array.isArray(transformed)) {
          return transformed[0];
        }
        return transformed;
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  currentIssuingEntity(): IssuingEntity {
    try {
      const transformed = plainToClass(
        IssuingEntity,
        JSON.parse(localStorage.getItem("issuingEntity"))
      );

      if (transformed) {
        if (Array.isArray(transformed)) {
          return transformed[0];
        }
        return transformed;
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  getIssuingEntitiesUser(): IssuingEntity[] {
    try {
      const transformed = plainToClass(
        User,
        JSON.parse(localStorage.getItem("currentUser"))
      );

      if (transformed) {
        if (Array.isArray(transformed)) {
          return transformed[0];
        }
        return transformed.issuingEntites;
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  currentProgram(): Program {
    try {
      const transformed = plainToClass(
        Program,
        JSON.parse(localStorage.getItem("currentProgram"))
      );

      if (transformed) {
        if (Array.isArray(transformed)) {
          return transformed[0];
        }
        return transformed;
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  setCurrentUser(user: User): any {
    localStorage.setItem("currentUser", JSON.stringify(user));
  }

  setCurrentProgram(program: Program): any {
    program.lastUpdate = new Date();
    localStorage.setItem("currentProgram", JSON.stringify(program));
  }
}
